import { Component, OnInit } from "@angular/core";
import { Shop, ValueExcelField, ValueField } from "cilor-db-api-shared";
import { ValuesService } from "../service/values.service";

@Component({
  selector: "app-values-page",
  templateUrl: "./values-page.component.html",
  styleUrls: ["./values-page.component.scss"]
})
export class ValuesPageComponent implements OnInit {
  ValueExcelField = ValueExcelField;
  ValueField = ValueField;
  Shop = Shop;

  constructor(
    public readonly valuesService: ValuesService,
  ) { }

  public async ngOnInit(): Promise<void> {
    await this.valuesService.loadValues();
  }

  public valueExcelFields(): string[] {
    return Object.values(ValueExcelField);
  }

  public isLoading(): boolean {
    return this.valuesService.loading;
  }
}
